import { DataProxy } from '@apollo/client'

import { CachedListUpdateStrategy, updateCachedItem, updateCachedList } from '@acre/utils'
import {
  AddCasePropertyMutation,
  AddPropertyMutation,
  GetCasePropertiesDocument,
  GetClientPropertiesDocument,
  GetPropertyDocument,
  PropertyVersion,
} from '@acre/graphql'

export const propertyTypes = {
  'preference-target-property': 'new_property',
  'preference-related-property-sale': 'remortgage_property',
}

export const updatePropertiesPost = async (cache: DataProxy, data: AddPropertyMutation, clientId: string) => {
  const { addProperty } = data

  if (addProperty) {
    const readQuery = {
      query: GetClientPropertiesDocument,
      variables: { id: clientId },
    }

    const payload = {
      readQuery,
      writeQuery: readQuery,
      newItem: addProperty,
      strategy: CachedListUpdateStrategy.Prepend,
      key: `client.details.properties`,
    }

    await updateCachedList<AddPropertyMutation['addProperty']>(cache, payload)
  }
}

export const updateCasePropertyPost = async (cache: DataProxy, data: AddCasePropertyMutation, caseId: string) => {
  const { addCaseProperty } = data

  if (addCaseProperty) {
    const readQuery = {
      query: GetCasePropertiesDocument,
      variables: { id: caseId },
    }

    const payload = {
      readQuery,
      writeQuery: readQuery,
      newItem: addCaseProperty,
      strategy: CachedListUpdateStrategy.Prepend,
      key: `case.details.properties`,
    }

    await updateCachedList<AddCasePropertyMutation['addCaseProperty']>(cache, payload)
  }
}

export const updateGetPropertyCache = async (proxy: DataProxy, data: AddCasePropertyMutation, type: string) => {
  const { addCaseProperty } = data
  if (!addCaseProperty || !type) return

  let property: PropertyVersion | null | undefined = null
  let propertyId: string | null | undefined = null
  if (type === 'preference_target_property') {
    property = addCaseProperty.details.new_property
    propertyId = addCaseProperty.details.preference_target_property
  }
  if (type === 'preference_related_property_sale') {
    property = addCaseProperty.details.remortgage_property
    propertyId = addCaseProperty.details.preference_related_property_sale
  }

  if (!propertyId || !property) return

  await updateCachedItem(proxy, {
    query: GetPropertyDocument,
    variables: { id: propertyId },
    data: property!,
    key: 'property',
  })
}
